import React from 'react';
import Button from '@material-ui/core/Button';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import checkIsMobile from 'utils/CheckIsMobile';

type InputAdvisoryProps = {
	inputError: boolean;
	buttonBackName: string;
	buttonNextName: string;
	handleBackClick: any;
	handleNextClick: any;
};

function ControlAdvisory({
	inputError,
	buttonBackName,
	buttonNextName,
	handleBackClick,
	handleNextClick,
}: InputAdvisoryProps) {
	const size = checkIsMobile() ? 'medium' : 'large';

	return (
		<div className="ControlAdvisory">
			<div className="controls">
				<Button variant="outlined" color="secondary" onClick={() => handleBackClick()}>
					{buttonBackName}
				</Button>

				<Button
					disabled={inputError}
					variant="contained"
					color="primary"
					size={size}
					endIcon={<ArrowForwardIcon />}
					onClick={() => handleNextClick()}
				>
					{buttonNextName}
				</Button>
			</div>
		</div>
	);
}

export default ControlAdvisory;
